export const contactsData = {
    email: 'whatsufsachin@gmail.com',
    phone: '+9779814526277',
    address: 'Bharatpur,Chitwan,Nepal',

    sheetAPI: ''
}